module.exports = __webpack_public_path__ + "static/media/default_asset.9ef538f6.jpg";